export default {
  get name(): string {
    return 'ExpoSecureStore';
  },
  async getValueWithKeyAsync(): Promise<null> {
    return null;
  },
};
